import React, {Component} from 'react'
import PartnersContainer from './PartnersContainer'
import '../styles/_index.scss'

class PartnersPage extends Component {
    render() {
        return (
            <div className="PartnersPage">
                <PartnersContainer />
            </div>
        )
    }
}

export default PartnersPage